// @flow
import { navigate as gatsbyNavigate } from 'gatsby';

import { helper as siteNavHelper } from '@waglabs/site-navigation';

type NavigateOptions = {
  disableForwardingQueryParams: boolean,
  state?: any;
  replace?: boolean;
};

export const navigate = (
  url: string,
  options: NavigateOptions = {},
) => {
  const {
    disableForwardingQueryParams,
    ...rest
  } = options;

  if (disableForwardingQueryParams) {
    return gatsbyNavigate(url, rest);
  }

  const {
    url: builtURL,
  } = siteNavHelper.urlStringBuilder()
    .createQueryString(url)
    .build();

  return gatsbyNavigate(builtURL, rest);
};
